import Axios from "axios";
import {
  SET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST,
  UNSET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getEmployeeBonusHistoryReport,
} from "@/store/api";

const state = {
  getEmployeeBonusHistoryReport: [],
};

const getters = {
  getEmployeeBonusHistoryReport(state) {
    return state.getEmployeeBonusHistoryReport;
  },
};

const mutations = {
  [SET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST](state, data) {
    state.getEmployeeBonusHistoryReport = data;
  },
  [UNSET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST](state) {
    state.getEmployeeBonusHistoryReport = [];
  },
};

const actions = {
  getEmployeeBonusHistoryReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeBonusHistoryReport}`, { params: data })
        .then((response) => {
          commit(SET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

